export const isDev = (): boolean => import.meta.env.DEV;
